import { createAction, props } from '@ngrx/store';
import { Package } from '../../models/package';

export const packageEditorSetPackage = createAction(
    '[Package Editor] Set Package',
    props<{ pkg: Partial<Package> }>()
);

export const packageEditorLoadRequest = createAction(
    '[Package Editor] Load',
    props<{ id: string }>()
);

export const packageEditorLoadComplete = createAction(
    '[Package Editor] Load Complete',
    props<{ pkg: Package }>()
);

export const packageEditorLoadFailure = createAction(
    '[Package Editor] Load Failure'
);

export const packageEditorSaveRequest = createAction(
    '[Package Editor] Save Request'
);

export const packageEditorSaveSuccess = createAction(
    '[PackageEditor] Save Succeeded'
);

export const packageEditorSaveFailure = createAction(
    '[PackageEditor] Save Failure'
);

export const packageEditorNew = createAction(
    '[PackageEditor] New'
);

